import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';

import FormGroup from '../helpers/FormGroup';

import { Tag } from './Tag';

// By default includeOperator and excludeOperator will be 'or' if not set, so we can treat undefined as 'or' in the component logic.
// This allows us to avoid setting default props and simplifies the component usage.

const GroupedTagsComponent = ({
  selectedList,
  onChangeStatus,
  onRemoveTag,
  onChangeOperator,
  excludeOperator,
  includeOperator,
  filterName,
}) => {
  const tagIncludeList = selectedList
    .map(
      (tag, index) =>
        // Use map instead of filter to preserve original index for correct callbacks
        !tag.get('exclude') && (
          <Tag
            key={index}
            index={index}
            onChangeStatus={onChangeStatus}
            onRemoveTag={onRemoveTag}
            value={tag.get('value')}
          />
        ),
    )
    .filter(Boolean);

  const tagExcludeList = selectedList
    .map(
      (tag, index) =>
        // Use map instead of filter to preserve original index for correct callbacks
        tag.get('exclude') && (
          <Tag
            key={index}
            index={index}
            onChangeStatus={onChangeStatus}
            onRemoveTag={onRemoveTag}
            value={tag.get('value')}
            exclude
          />
        ),
    )
    .filter(Boolean);
  const nameInclude = `include-${filterName}`;
  const labelIncludeOr = `include-or-${filterName}`;
  const labelIncludeAnd = `include-and-${filterName}`;
  const nameExclude = `exclude-${filterName}`;
  const labelExcludeOr = `exclude-or-${filterName}`;
  const labelExcludeAnd = `exclude-and-${filterName}`;

  return (
    <div>
      {tagIncludeList.size > 0 && (
        <div>
          <span>Include</span>
          {tagIncludeList}
          <FormGroup>
            <div className="radio-wrap radio-wrap--reverse">
              <label htmlFor={labelIncludeOr}>Match any criteria (OR)</label>
              <input
                checked={includeOperator === 'or' || !includeOperator}
                id={labelIncludeOr}
                name={nameInclude}
                onChange={() => onChangeOperator('or')}
                type="radio"
                value="or"
              />
            </div>
          </FormGroup>
          <FormGroup>
            <div className="radio-wrap radio-wrap--reverse">
              <label htmlFor={labelIncludeAnd}>Match all criteria (AND)</label>
              <input
                checked={includeOperator === 'and'}
                id={labelIncludeAnd}
                name={nameInclude}
                onChange={() => onChangeOperator('and')}
                type="radio"
                value="and"
              />
            </div>
          </FormGroup>
        </div>
      )}
      {tagExcludeList.size > 0 && (
        <div>
          <span>Exclude</span>
          {tagExcludeList}
          <FormGroup>
            <div className="radio-wrap radio-wrap--reverse">
              <label htmlFor={labelExcludeOr}>Match any criteria (OR)</label>
              <input
                checked={excludeOperator === 'or' || !excludeOperator}
                id={labelExcludeOr}
                name={nameExclude}
                onChange={() => onChangeOperator('or', true)}
                type="radio"
                value="or"
              />
            </div>
          </FormGroup>
          <FormGroup>
            <div className="radio-wrap radio-wrap--reverse">
              <label htmlFor={labelExcludeAnd}>Match all criteria (AND)</label>
              <input
                checked={excludeOperator === 'and'}
                id={labelExcludeAnd}
                name={nameExclude}
                onChange={() => onChangeOperator('and', true)}
                type="radio"
                value="and"
              />
            </div>
          </FormGroup>
        </div>
      )}
    </div>
  );
};

GroupedTagsComponent.propTypes = {
  excludeOperator: PropTypes.oneOf(['or', 'and', undefined]),
  filterName: PropTypes.string.isRequired,
  includeOperator: PropTypes.oneOf(['or', 'and', undefined]),
  onChangeOperator: PropTypes.func.isRequired,
  onChangeStatus: PropTypes.func.isRequired,
  onRemoveTag: PropTypes.func.isRequired,
  selectedList: PropTypes.instanceOf(List).isRequired,
};

/** Grouped tags component. */
export const GroupedTags = memo(GroupedTagsComponent);
